import { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

/** @note custom hook to capture search params for registration form */
export const useRegisterForm = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const [initialValues, setInitialValues] = useState({
        companyName: '',
        entityName: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        contactNumber: '',
        partnerCode: '',
        approvalCode: '',
        recaptchaToken: '',
    });

    useEffect(() => {
        // Parse query parameters
        const approvalCode = searchParams.get('approvalcode');
        const partnerCodeFromQuery = searchParams.get('partnercode');
        const companyName = searchParams.get('companyname');
        const entityName = searchParams.get('entityname');
        const firstName = searchParams.get('firstname');
        const lastName = searchParams.get('lastname');
        const email = searchParams.get('email');
        const contactNumber = searchParams.get('telephonenumber');

        // Check for partner code in URL path (e.g., /register/partnercode)
        const pathSegments = location.pathname.split('/register/');
        const partnerCodeFromPath =
            pathSegments.length > 1 ? pathSegments[1] : '';

        const updatedValues = {
            companyName: companyName || '',
            entityName: entityName || '',
            firstName: firstName || '',
            lastName: lastName || '',
            email: email || '',
            password: '',
            confirmPassword: '',
            contactNumber: contactNumber || '',
            partnerCode: partnerCodeFromPath || partnerCodeFromQuery || '',
            approvalCode: approvalCode || '',
            recaptchaToken: '',
        };

        setInitialValues(updatedValues);
    }, [searchParams, location.pathname]);

    return { initialValues };
};
